import PropTypes from 'prop-types';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { EMPTY_PROPERTY_VALUE } from '../../constants/EmptyPropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { getMonthsPerPeriod } from '../utils/period';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyMonthPeriod = props => {
  const {
    className,
    placeholder = EMPTY_PROPERTY_VALUE
  } = props;
  const propertyValue = usePropertyValue();
  const months = getMonthsPerPeriod(propertyValue);
  return /*#__PURE__*/_jsx("span", Object.assign({
    className: className
  }, getDataAttributes(props), {
    children: months === null ? placeholder : months
  }));
};
FormattedPropertyMonthPeriod.displayName = 'FormattedPropertyMonthPeriod';
FormattedPropertyMonthPeriod.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.node
};
export default FormattedPropertyMonthPeriod;